<ng-progress color="red" [thick]="true" [spinner]="false" [trickleSpeed]="500" [ease]="'easeInSine'" (started)="ngProgress.startedClass" (completed)="ngProgress.endedClass"></ng-progress>
<div class="page-contents" id="toplevelsub">
    <div class="subBlockContainer">
        <div class="breadcrumbWrapper">
            <app-breadcrumb></app-breadcrumb>
        </div>
        <mat-sidenav-container class="sidenav-container" style="height: 100%; position: unset;background: white;" [hasBackdrop]="false">
            <div class="subBlockContent" *ngIf="!narrowMode">
                <child-header [title]="title" (closeEvent)="navigateTo('/home')"></child-header>
                <loading-screen *ngIf="!loadContent" [showInnerLoading]="true" (currentLoadingStatus)="onLoading($event)"></loading-screen>

                <div *ngIf="loadContent" class="inner-subBlock-wrapper row" style="margin: 20px 20px 0px 20px;">
                    <div class="page-subtitle-wrapper">CUSTOMERS</div>
                </div>
                
                <!-- filter -->
                <div *ngIf="loadContent" class="inner-subBlock-wrapper row" style="margin: 20px 20px 0px 20px;">
                    <div class="filter-wrapper">
                        <div class="col-md-3">
                            <div class="searchInputGroup toplevelsub" [class.narrowModeInput]="narrowMode">
                                <div class="searchIcon">
                                    <img src="../images/new_ui/filter.png">
                                </div>
                                <input class="searchInput" type="text" placeholder="Filter" onfocus="this.placeholder=''" onblur="this.placeholder='Filter'" [(ngModel)]="searchField">
                            </div>
                        </div>
                    </div>

                    <div class="migrate-all-button">
                        <button class="button button-red button-round" (click)="addCustomerEvent()">
                            &nbsp;Add Customer&nbsp;
                        </button>
                    </div>
                </div>

                <!-- list -->
                <div *ngIf="loadContent" class="child-body">
                    <div class="inner-subBlock-wrapper" *ngIf="customers">
                        <div class="noData-wrapper" *ngIf="!customers.length">
                            <div>
                                <img src="../images/new_ui/no-subscription.png">
                            </div>
                            <label class="noData-label">
                                We couldn't find any <br />
                                customers
                            </label>
                        </div>

                        
                        <ng-container *ngIf="customers.length">
                            <table  mat-table matSort [dataSource]="dataSource">
                                <ng-container matColumnDef="customerName">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header="endUserName" style="width: 841px; "> CUSTOMER NAME </th>
                                    <td mat-cell *matCellDef="let customer" style="width: 841px;"> {{ customer?.companyName }} </td>
                                </ng-container>
                                <ng-container matColumnDef="manage">
                                    <th mat-header-cell *matHeaderCellDef> </th>
                                    <td mat-cell *matCellDef="let customer" class="center-button">
                                        <button class="button button-red button-round" (click)="manageCustomerEvent(customer)">
                                            &nbsp;Manage&nbsp;
                                        </button>
                                    </td>
                                </ng-container>

                                <tr mat-header-row *matHeaderRowDef="displayedColumns;"></tr>
                                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                            </table>
                        </ng-container>
                    </div>

                </div>
            </div>

            <div class="blockContainer narrow-sidebar subBlockContainer_toplevel" id='levelOne' *ngIf="narrowMode">
                <div style="display: flex; width: 800%; height: 100%; overflow-x: auto;">
                    <div class="child-sidebar" style="border-right: 1px solid #dee2e6; flex-shrink: 0">
                        <div [class.loader-border]="hideFirstLevel">
                            <child-header [title]="title" (closeEvent)="close()"></child-header>
                            <div class="child-body" style="padding: 23px 0;">
                                <div class="searchInputGroup">
                                    <div class="searchIcon search-carts">
                                        <img src="../images/new_ui/filter.png">
                                    </div>
                                    <input class="searchInput" type="text" placeholder="Filter" onfocus="this.placeholder=''" onblur="this.placeholder='Filter'" [(ngModel)]="searchField">
                                </div>

                                <ng-container *ngFor="let c of customers | TableFilter: 'companyName': searchField">
                                    <div class="menu-wrapper" [class.active]="isActive(c?.id)" style="text-align: center;" (click)="manageCustomerEvent(c)">
                                        <label  class="small-title">{{c.companyName}}</label>
                                    </div>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                    <div style="flex-shrink: 0">
                        <router-outlet></router-outlet>
                    </div>
                </div>

            </div>
        </mat-sidenav-container>
    </div>
</div>